export default "__VITE_ASSET__DX63Mg8G__"